module.exports = __webpack_public_path__ + "static/img/right_brd.a080caab.png";